import removeModerator from "~/store/graphql/mutations/removeSiteModerator.gql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

export default async function removeSiteModerator({ commit }, { params }) {
  await runGraphQLQuery(removeModerator, params, this.$axios);

  return Promise.resolve();
}
